import IUser from '~/Models/DTO/User.model';
import { routeReplacer } from '~/Helpers/String.helper';
import { IProviderProfilePicture } from '~/Models/DTO/Provider.model';
import { IChangePasswordPayload } from '..';
import { CORE_SERVICE_URLS, USER_SERVICE_URLS } from '../../../Constants/Urls.constants';
import { IRequestWithCallBack } from '../../../Hooks/useRequest';
import { IErrorResponse } from '../../../Models/DTO/Error.models';

export const setProfilePicture = async (
  request: IRequestWithCallBack,
  payload: Partial<IProviderProfilePicture>,
  domain: string,
  setData: (data: Partial<IProviderProfilePicture>) => void,
  setError: (error: IErrorResponse) => void,
) => {
  await request<Partial<IProviderProfilePicture>>(
    {
      url: routeReplacer(CORE_SERVICE_URLS.PROVIDER_IMAGES, { domain }),
      method: 'POST',
      data: JSON.stringify(payload),
    },
    (data) => setData(data),
    (error) => setError(error),
  );
};

export const changePassword = (
  request: IRequestWithCallBack,
  payload: IChangePasswordPayload,
  setData: (user: IUser) => void,
  setError: (error: IErrorResponse) => void,
) => {
  request<IUser>(
    {
      url: USER_SERVICE_URLS.CHANGE_PASSWORD,
      data: JSON.stringify(payload),
      method: 'PATCH',
    },
    (data) => setData(data),
    (error) => setError(error),
  );
};
